import Vue from "vue";

import { getUserInfo, logout } from "@/api/user";
import { getToken, setToken, setExpiresIn, removeToken } from '@/utils/auth'

export const state = Vue.observable({
  token: '',
  isLogin: false,
  userInfo: {},
});

const store = {
  state,

  setLoginStatus(isLogin) {
    state.isLogin = isLogin;
  },
  setLoginToken(token) {
    setToken(token)
  },
  setTokenExpiresIn(time) {
    setExpiresIn(time)
  },
  setUserInfo(userInfo) {
    state.userInfo = userInfo;
  },
  expireLogin() {
    state.isLogin = false;
    removeToken();
    state.userInfo = {};
  },


  requestLoginStatus() {
    return fetchLoginStatus()
      .then((response) => {
        store.setLoginStatus(response.data);
        return response.data;
      })
      .catch((err) => Promise.reject(err));
  },

  requestLogout() {
    return logout().then((res) => {
        if (res.code === 200) {
          store.expireLogin();
        }
      })
      .catch((err) => Promise.reject(err));
  },

  requestUserInfo() {
    return new Promise((resolve, reject) => {
      // 向后端请求路由数据
      getUserInfo().then((response) => {
        store.setUserInfo(response.data);
        store.setLoginStatus(true);
        resolve();
      }).catch(err => {
        reject();
      });
    });
  }
    
};
export default store;

// window.addEventListener("beforeunload", () => {
//   localStorage.setItem("account", JSON.stringify(state));
// });

// window.addEventListener("DOMContentLoaded", () => {
// try {
//   var account = JSON.parse(localStorage.getItem("account"));
// } catch (error) {
//   account = {};
// }
// state.isLogin = account.isLogin;
// state.userInfo = account.userInfo;
// });
